import cookieService from "@/services/storage/cookie.client";
import apiDriveMagasin from "@/services/http/api-drive/magasin";
import { StatusTypes, useMagasinStore } from "@/store/magasin";
import { useContextStore } from "@/store/context";
import { useAuthStore } from "@/store/auth";

export default defineNuxtPlugin(async ({ $pinia, $apiDrive }) => {

  const magasinStore = useMagasinStore($pinia);
  const contextStore = useContextStore($pinia);
  const authStore = useAuthStore($pinia);
  const config = useRuntimeConfig();
  const route = useRoute();

  if (magasinStore.resetCookieToNational) {
    cookieService.set(config.public.COOKIES_MAGASIN_NAME, config.MAGASINS_NATIONAL, {
      expires: config.COOKIES_MAGASIN_EXPIRES,
      secure: config.public.SECURE_COOKIES
    });
    magasinStore.setResetCookieToNational(false);
  }

  if (!route.query.magasin_id && Date.now() - contextStore.requestTime > config.public.API_DRIVE_CACHE_RELOAD_DELAY_MAGASIN && !authStore.isLogged) {
    await magasinStore.fetchMagasin(magasinStore.id);
    return;
  }
  if (!route.query.magasin_id) {
    return;
  }
  const magasinId = magasinStore.id;
  // Gestion aliasWeb à la place de l'ID
  // Cas d'accès à un magasin qui n'existe pas
  if (magasinStore.status === StatusTypes.GET_MAGASIN_SUCCESS_REDIRECT) {
    cookieService.set(config.public.COOKIES_MAGASIN_NAME, magasinId, {
      expires: config.COOKIES_MAGASIN_EXPIRES,
      secure: config.public.SECURE_COOKIES
    });
    return;
  }

  const oldMagasinId = cookieService.get(config.public.COOKIES_MAGASIN_NAME);

  if (oldMagasinId && +magasinId !== +oldMagasinId && +oldMagasinId !== +config.public.MAGASINS_NATIONAL) {
    magasinStore.setOldMagasin(await $apiDrive.use(apiDriveMagasin).magasin(oldMagasinId));
    magasinStore.setNewMagasin(await $apiDrive.use(apiDriveMagasin).magasin(magasinId));
  } else {
    cookieService.set(config.public.COOKIES_MAGASIN_NAME, magasinId, {
      expires: config.public.COOKIES_MAGASIN_EXPIRES,
      secure: config.public.SECURE_COOKIES
    });
  }
});
